import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import moment from "moment";

class Fila extends Component {
  render() {
    const {
      nombreAlumno,
      apellido1,
      apellido2,
      fechaBaja,
      nombreColegio,
      actividad
    } = this.props.baja;
    return (
      <Table.Row>
        <Table.Cell content={nombreAlumno} />
        <Table.Cell content={`${apellido1} ${apellido2}`} />
        <Table.Cell
          content={moment(fechaBaja, "YYYYMMDD").format("DD/MM/YYYY")}
        />
        <Table.Cell content={nombreColegio} />
        <Table.Cell content={actividad} />
      </Table.Row>
    );
  }
}

export default Fila;



// WEBPACK FOOTER //
// ./src/pages/listados/listadoBajas/tabla/Fila.jsx